import { Box, Divider, Grid, Typography } from "@mui/material";
import {
  CheckBox,
  DateBox,
  NumberBox,
  TextArea,
  TextBox,
} from "devextreme-react";
import { NativeEventInfo } from "devextreme/events";
import { locale } from "devextreme/localization";
import dxCheckBox from "devextreme/ui/check_box";
import dxDateBox from "devextreme/ui/date_box";
import { ValueChangedInfo } from "devextreme/ui/editor/editor";
import notify from "devextreme/ui/notify";
import dxNumberBox from "devextreme/ui/number_box";
import dxTextArea from "devextreme/ui/text_area";
import dxTextBox from "devextreme/ui/text_box";
import TImeUtils from "../../../Utils/TimeUtils";
import { smallTime } from "../../../Models/Utils/Utils";
import React, { useEffect } from "react";
import {
  CustomOtherKeysToSet,
  Key,
} from "../../../Models/Project/CustomOtherKeysToSet";
import { Form } from "../../../Models/SysConf/Form";
import { FormField } from "../../../Models/SysConf/FormField";
import { FormGroup } from "../../../Models/SysConf/FormGroup";
import { CustomEvents } from "../../../Utils/CustomEvents";
import { getFormFields, getType, types } from "../../../Utils/EsaedroHelper";
import FormatTypes from "../../../Utils/FormatTypes";
import ArticoliLookup from "../../CustomEdit/ArticoliLookup/ArticoliLookup";
import PrevMaterialiLookup from "../../CustomEdit/PrevMaterialiLookup/PrevMaterialiLookup";
import { FieldsNotVisible } from "../../ObjectEdit/ObjectEdit";
import Lookup, {
  CustomLookupFilter,
  EsaedroLookupHandleChangeEvent,
} from "../Lookup/Lookup";
import LookupNew from "../Lookup/LookupNew";
import Esaedro_TextBarcode from "../Esaedro_TextBarcode";
import saveNewSessione from "../../CustomForms/FormSessioniLavoro";
const clone = require("clone");

export type RenderFormProps = {
  showTitle?: boolean;

  isNew: boolean;
  isCustom?: boolean;

  form: Form | undefined;
  numberOfDecimals?: any[]; // [{fieldName: '', numberOfDecimals: 2}]

  myObj: any; //Oggetto da modificare - dipende se isCustom è true o false

  otherKeysToSet?: CustomOtherKeysToSet[]; //Contiene le chiavi di un oggetto che devono essere settate [{fieldName: '', arrayKeys: [{keyObj: '', keyValue: ''}]}]

  onCustomHandleChange?: (objChanged: any, fieldName: string) => void;
  onCustomRenderField?: (editedObject: any, field: FormField) => void;

  saveNewObject?: (newObject: any, fieldName?: string) => void; //Ogni handleChange() alla fine verrà chiamato questo metodo per salvare l'oggetto nell'componente padre

  reloadForm?: () => void; //Ricarica il form
  reloadObject?: () => void; //Ricarica l'oggetto

  onCommandCancelForm?: () => void; //funzione chiamata quando il comando del format type è annulla:customForm
  onCommandSaveForm?: () => void;
  onCommandSaveNewForm?: () => void;
  emptyRequiredField?: () => void;
  customFiltersLookup?: {
    [key: string]: CustomLookupFilter[]; // -> La key sarà il nome della lookup
  };
  isValid?: boolean;
};

const RenderFormNew = (props: RenderFormProps) => {
  const {
    showTitle = true,

    isNew,
    isCustom = false,

    form,
    isValid,
  } = props;

  // Key incrementali delle lookup (nome campo in chiave) - Se incrementate triggerano il render sulla relativa lookup
  const [lookupKeys, setLookupKeys] = React.useState<Map<string, number>>(
    new Map()
  );

  var [myObject, setMyObject] = React.useState<any>(undefined);
  // Mi creo le mappe per gestire le lookup come variabili fuori dallo stato
  // Nomi dei campi delle lookup che hanno campi da controllare
  const refLookupFieldsWithFieldsToCheck = React.useRef<string[]>([]);

  // Campi da controllare per ogni lookup (nome campo in chiave)
  const [lookupFieldsToCheck, setLookupFieldsToCheck] = React.useState<
    Map<string, any[]>
  >(new Map());

  // Funzione deprecata, la tengo per ora
  const checkOtherKeysToSet = (fieldName: string) => {
    if (props.otherKeysToSet && props.otherKeysToSet.length > 0) {
      let fieldKeyToChange = props.otherKeysToSet.find(
        (key: any) => key.fieldName == fieldName
      );

      if (fieldKeyToChange) {
        return fieldKeyToChange.arrayKeys;
      } else {
        return [];
      }
    }

    return [];
  };

  const lookupLoadedFieldsToCheck = (
    fieldName: string,
    fieldsToCheck: any[]
  ) => {
    // Setto i fields to check nella mappa
    if (!refLookupFieldsWithFieldsToCheck.current.includes(fieldName)) {
      refLookupFieldsWithFieldsToCheck.current = [
        ...refLookupFieldsWithFieldsToCheck.current,
        fieldName,
      ];
      // lookupFieldsToCheck.set(fieldName, fieldsToCheck)
    }
    lookupFieldsToCheck.set(fieldName, fieldsToCheck);
  };

  /* --------------------------------------------------------------------- */
  const handleChangeLookup = (event: EsaedroLookupHandleChangeEvent) => {
    let tempObj: any = undefined;

    tempObj = clone(props.myObj);

    // Se è una lookup faccio un controllo sui campi da controllare. Se sono cambiati cambio la chiave a quella lookup, incrementandola nella relativa mappa
    refLookupFieldsWithFieldsToCheck.current.forEach((field: string) => {
      var fieldsToCheck = lookupFieldsToCheck.get(field);

      if (fieldsToCheck) {
        for (var i = 0; i < fieldsToCheck.length; i++) {
          if (fieldsToCheck[i] == event.fieldName) {
            let newKey = lookupKeys.get(field);
            if (newKey == undefined) newKey = 0;
            lookupKeys.set(field, newKey + 1);
          }
        }
      }
    });

    tempObj[event.fieldName] = event.value;

    // Controllo se devo settare altre chiavi all'oggetto
    if (
      event.selectedRowsData.length > 0 &&
      event.resourceLookupValues.length > 0 &&
      event.selectedRowsData.length > 0
    ) {
      for (let i = 0; i < event.resourceLookupValues.length; i++) {
        let aliasFieldName =
          event.resourceLookupValues[i].ValueField_Name_Alias;
        let ValueField_Name = event.resourceLookupValues[i].ValueField_Name;

        if (aliasFieldName && aliasFieldName !== "") {
          tempObj[aliasFieldName] = event.selectedRowsData[0][ValueField_Name];
        } else {
          tempObj[ValueField_Name] = event.selectedRowsData[0][ValueField_Name];
        }

        // tmpObj[event.resourceLookupValues[i].fieldName] = event.resourceLookupValues[i].ValueField_Name_Alias;
      }
    }

    // Controllo se il campo è ha un DecodeField
    if (props.form) {
      let allFields = getFormFields(props.form);
      var field = allFields.find((field) => field.FieldName == event.fieldName);
      if (field && field.DecodeField && field.LookupValues.length > 0) {
        let decodeFieldName = field.DecodeField.trim();
        let decodeField = allFields.find(
          (fieldDecoded) => fieldDecoded.FieldName == decodeFieldName
        );
        if (decodeField && decodeField.Is_Decode) {
          // Assegno il valore al campo DecodeField
          let lookupValues = field.LookupValues; // _value=_description|_value2=_description2

          // Scompone la stringa in un array di stringhe
          let lookupValuesArray = lookupValues.split("|"); // [_value=_description, _value2=_description2]

          // Cerco il valore della lookup
          let lookupValue = lookupValuesArray.find((value: string) => {
            let valueArray = value.split("="); // [_value, _description]
            return valueArray[0] == event.value;
          }); // _value=_description

          // Assegno il valore del decodeField
          if (lookupValue) {
            let lookupValueArray = lookupValue.split("="); // [_value, _description]
            tempObj[decodeFieldName] = lookupValueArray[1];
          }
        }
      }
    }

    // Inserisco qui l'eventuale callback -> utilizzato nei customComponent
    if (props.onCustomHandleChange)
      props.onCustomHandleChange(tempObj, event.fieldName);

    //Faccio gestire il salvataggio all'oggetto padre, poichè nel render utilizzo come value this.props.myObj
    if (props.saveNewObject) props.saveNewObject(tempObj, event.fieldName);
    else console.warn("saveNewObject non impostato");
  };

  const handleChangeDevExtreme = (
    event: NativeEventInfo<
      dxCheckBox | dxDateBox | dxNumberBox | dxTextArea | dxTextBox
    > &
      ValueChangedInfo
  ) => {
    var name = event.element.id;
    var value = event.value;

    let tempObj = JSON.parse(JSON.stringify(props.myObj));

    //tempObj = clone(props.myObj);

    tempObj[name] = value;

    // Inserisco qui l'eventuale callback -> utilizzato nei customComponent
    if (props.onCustomHandleChange) props.onCustomHandleChange(tempObj, name);

    //Faccio gestire il salvataggio all'oggetto padre, poichè nel render utilizzo come value this.props.myObj
    if (props.saveNewObject) props.saveNewObject(tempObj, name);
    else console.warn("saveNewObject non impostato");
  };

  function pad(num: any, size: number) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }

  //da implementare con barcodeType invece di string
  const handleBarcodeCommand = (command: string) => {
    if (command === "SALVA") {
      props.onCommandSaveForm?.();
    }

    if (command === "ANNULLA") {
      props.onCommandCancelForm?.();
    }
    if (command === "SALVANUOVO") {
      props.onCommandSaveNewForm?.();
    }
  };

  const handleChangeTimeBox = (
    event: NativeEventInfo<
      dxCheckBox | dxDateBox | dxNumberBox | dxTextArea | dxTextBox
    > &
      ValueChangedInfo
  ) => {
    var name = event.element.id;
    var value = event.value;

    let tempObj = JSON.parse(JSON.stringify(props.myObj));

    //tempObj = clone(props.myObj);

    // tempObj[name] = value;
    let d = new Date(value);
    let newValue = pad(d.getHours(), 2) + ":" + pad(d.getMinutes(), 2);

    tempObj[name] = newValue;

    // Inserisco qui l'eventuale callback -> utilizzato nei customComponent
    if (props.onCustomHandleChange) props.onCustomHandleChange(tempObj, name);

    //Faccio gestire il salvataggio all'oggetto padre, poichè nel render utilizzo come value this.props.myObj
    console.log("Prima salvataoggio");
    if (props.saveNewObject) props.saveNewObject(tempObj);
    else console.warn("saveNewObject non impostato");
    console.log("Dopo salvataggio");
  };

  const handleChange = (event: any) => {
    var type = event.type ? event.type : event.component.NAME; //Se è un coponente di DevExtreme conterrà la parola dx

    // Controllo come prima cosa che non si tratti di un customEvent -> RIMASTO UGUALE
    if (type == CustomEvents.DeleteFile) {
      notify("Metodo DeleteFile non implementato", "error", 2000);
    } else if (type == CustomEvents.JSONObjectChanged) {
      notify("Metodo JSONObjectChanged non implementato", "error", 2000);
    } else {
      const target = event.target ? event.target : null;
      var value: any = undefined;

      if (target) type = event.target.type;

      if (type == "file") {
        notify("Metodo file non implementato", "error", 2000);
      } else {
        notify("Metodo handleChange non implementato", "error", 2000);
      }
    }
  };

  const renderFormField = (
    field: FormField,
    index: number,
    numCols: number = 1
  ) => {
    var labelSizeRatio = field.LabelSizeRatio ?? 4;
    var fieldSizeRatio = field.FieldSizeRatio ?? 12 - labelSizeRatio;

    // if (myObjectEdit === undefined || myObjectEdit.objectToEdit === undefined) return null;

    // Qui la lista è filtrata a monte in caso di update, va gestita in caso di insert - TODO capire come gestirla
    if (isNew && !field.Is_Visible && !field.Is_Key && !field.Is_Nullable)
      return null;

    // Questi campi non devono mai essere visibili
    if (FieldsNotVisible.includes(field.FieldName)) return null;

    // Se è di tipo Object List non devo mostrarlo
    if (
      field.Reffered_Resource_Type == 1 ||
      field.Is_Decode ||
      field.Is_Identity
    )
      return;

    // Avviso se c'è un errore nella programmazione della maschera
    if (isNew && !field.Is_Visible && (field.Is_Key || !field.Is_Nullable)) {
      field.HelperText = "ERRORE - Campo chiave o non nullabile";
      field.Is_Editable = false;
    }

    // Se è sync o siamo in edit ed è chiave il campo deve essere ReadOnly
    const disableEdit =
      props.myObj &&
      props.myObj.disableEdit !== undefined &&
      props.myObj.disableEdit
        ? props.myObj.disableEdit
        : false;
    if (field.Is_Syncronized || (field.Is_Key && !isNew) || disableEdit)
      field.Is_Editable = false;

    // Se è chiave e non nullabile deve essere obbligatorio
    if (field.Is_Key || !field.Is_Nullable) field.Is_Required = true;

    // Inserisco qui l'eventuale callback
    if (props.onCustomRenderField) {
      props.onCustomRenderField(props.myObj, field);
    }

    if (!field.Is_Visible) return null;

    // Controllo se devo settare altri campi quando renderizzo un CustomEditComponent
    let otherKey: Key[] = checkOtherKeysToSet(field.FieldName);

    // var validationError = validateField(field);

    if (field.LookupName || field.LookupValues) {
      let customFiltersLookup: CustomLookupFilter[] | undefined = undefined;
      if (props.customFiltersLookup) {
        customFiltersLookup = props.customFiltersLookup[field.LookupName];
      }

      // console.log(props.customFiltersLookup);

      return (
        <Grid item xs={12} sm={12 / numCols} key={index}>
          <Box sx={{ width: "100%", height: "100%" }}>
            <Grid container spacing={2}>
              <Grid item xs={labelSizeRatio}>
                <Typography variant="body1">
                  {field.Field_Label} {field.Is_Required ? "*" : ""}
                </Typography>
              </Grid>
              <Grid item xs={fieldSizeRatio}>
                <Lookup
                  fieldName={field.FieldName}
                  value={props.myObj[field.FieldName]}
                  fatherObj={props.myObj}
                  onChange={handleChangeLookup}
                  lookupName={field.LookupName ? field.LookupName : ""}
                  lookupValues={field.LookupValues ? field.LookupValues : ""}
                  displayName={field.Field_Label}
                  isDisabled={!field.Is_Editable}
                  onFieldsToCheckLoaded={lookupLoadedFieldsToCheck}
                  key={lookupKeys.get(field.FieldName)}
                  //  isValid={!field.Is_Required || props.myObj[field.FieldName]} // Valid if not required or value exists
                  style={
                    !isValid &&
                    field.Is_Required && {
                      borderColor: !props.myObj[field.FieldName]
                        ? "red"
                        : undefined,
                      borderWidth: !props.myObj[field.FieldName]
                        ? "2px"
                        : undefined,
                      borderStyle: !props.myObj[field.FieldName]
                        ? "solid"
                        : undefined,
                    }
                  }
                />
                {/* Error message */}
                {!isValid &&
                  field.Is_Required &&
                  !props.myObj[field.FieldName] && (
                    <Typography variant="body2" color="error">
                      {`${field.Field_Label} è obbligatorio.`}
                    </Typography>
                  )}
              </Grid>
            </Grid>
          </Box>
        </Grid>
      );
    }

    // Controllo se è un pdf e nel caso gli assegno il Field_Type 400
    if (field.Field_Type == 200 && field.ContentType == "pdf")
      field.Field_Type = 400;

    // Se il FormatType è generico allora faccio il render partendo dal Field_Type
    let type = getType(field);

    if (
      field.FormatType === undefined ||
      field.FormatType === FormatTypes.Generico
    ) {
      // Renderizzo il campo in base al tipo
      switch (type) {
        case types.boolean:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}>
                    <CheckBox
                      name={field.FieldName}
                      id={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={props.myObj[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      style={
                        !isValid && field.Is_Required
                          ? {
                              borderColor: !props.myObj[field.FieldName]
                                ? "red"
                                : undefined,
                              borderWidth: !props.myObj[field.FieldName]
                                ? "2px"
                                : undefined,
                              borderStyle: !props.myObj[field.FieldName]
                                ? "solid"
                                : undefined,
                            }
                          : {}
                      }
                    />
                    {/* Error message */}
                    {!isValid &&
                      field.Is_Required &&
                      !props.myObj[field.FieldName] && (
                        <Typography variant="body2" color="error">
                          {`${field.Field_Label} è obbligatorio.`}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case types.datetime:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}>
                    <DateBox
                      type="date"
                      name={field.FieldName}
                      id={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={props.myObj[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      //displayFormat='dd-MM-yyyy'
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      style={
                        !isValid && field.Is_Required
                          ? {
                              borderColor: !props.myObj[field.FieldName]
                                ? "red"
                                : undefined,
                              borderWidth: !props.myObj[field.FieldName]
                                ? "2px"
                                : undefined,
                              borderStyle: !props.myObj[field.FieldName]
                                ? "solid"
                                : undefined,
                            }
                          : {}
                      }
                    />
                    {/* Error message */}
                    {!isValid &&
                      field.Is_Required &&
                      !props.myObj[field.FieldName] && (
                        <Typography variant="body2" color="error">
                          {`${field.Field_Label} è obbligatorio.`}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case types.date:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}>
                    <DateBox
                      type="date"
                      name={field.FieldName}
                      displayFormat="HH:mm"
                      id={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={props.myObj[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      //displayFormat='dd-MM-yyyy'
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      style={
                        !isValid && field.Is_Required
                          ? {
                              borderColor: !props.myObj[field.FieldName]
                                ? "red"
                                : undefined,
                              borderWidth: !props.myObj[field.FieldName]
                                ? "2px"
                                : undefined,
                              borderStyle: !props.myObj[field.FieldName]
                                ? "solid"
                                : undefined,
                            }
                          : {}
                      }
                    />
                    {/* Error message */}
                    {!isValid &&
                      field.Is_Required &&
                      !props.myObj[field.FieldName] && (
                        <Typography variant="body2" color="error">
                          {`${field.Field_Label} è obbligatorio.`}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case types.time:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} md={fieldSizeRatio}>
                    <DateBox
                      type="time"
                      name={field.FieldName}
                      id={field.FieldName}
                      disabled={!field.Is_Editable}
                      //  value={date && checkValidDate(date) ? date : undefined}
                      onValueChanged={handleChangeTimeBox}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      style={
                        !isValid && field.Is_Required
                          ? {
                              borderColor: !props.myObj[field.FieldName]
                                ? "red"
                                : undefined,
                              borderWidth: !props.myObj[field.FieldName]
                                ? "2px"
                                : undefined,
                              borderStyle: !props.myObj[field.FieldName]
                                ? "solid"
                                : undefined,
                            }
                          : {}
                      }
                    />
                    {/* Error message */}
                    {!isValid &&
                      field.Is_Required &&
                      !props.myObj[field.FieldName] && (
                        <Typography variant="body2" color="error">
                          {`${field.Field_Label} è obbligatorio.`}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case types.number:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}>
                    <NumberBox
                      name={field.FieldName}
                      id={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={props.myObj[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      style={
                        !isValid && field.Is_Required
                          ? {
                              borderColor: !props.myObj[field.FieldName]
                                ? "red"
                                : undefined,
                              borderWidth: !props.myObj[field.FieldName]
                                ? "2px"
                                : undefined,
                              borderStyle: !props.myObj[field.FieldName]
                                ? "solid"
                                : undefined,
                            }
                          : {}
                      }
                    />
                    {/* Error message */}
                    {!isValid &&
                      field.Is_Required &&
                      !props.myObj[field.FieldName] && (
                        <Typography variant="body2" color="error">
                          {`${field.Field_Label} è obbligatorio.`}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case types.pdf:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}></Grid>
                </Grid>
              </Box>
            </Grid>
          );

        // A data 03/01/2023 non è utilizzato. Matteo Urso
        case types.allegato:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio}>
                    <Typography variant="body1">
                      {field.Field_Label} {field.Is_Required ? "*" : ""} - Non
                      implementato
                    </Typography>
                  </Grid>
                  <Grid item xs={fieldSizeRatio}></Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case types.json:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}></Grid>
                </Grid>
              </Box>
            </Grid>
          );

        // Se sono delle righe, non faccio nulla
        case types.righe:
          return null;

        default:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}>
                    {field.Is_MultiRow ? (
                      <TextArea
                        name={field.FieldName}
                        disabled={!field.Is_Editable}
                        value={props.myObj[field.FieldName]}
                        onValueChanged={handleChangeDevExtreme}
                        id={field.FieldName}
                        inputAttr={{
                          rows: field.Rows && field.Rows > 0 ? field.Rows : 4,
                        }}
                        elementAttr={{
                          field: field.FieldName,
                        }}
                      />
                    ) : // TODO: da verificare se è corretto
                    field.FormatMask > "" &&
                      field.FormatMaskRules != undefined ? (
                      <TextBox
                        name={field.FieldName}
                        value={
                          props.myObj && props.myObj[field.FieldName]
                            ? props.myObj[field.FieldName]
                            : ""
                        } // TODO: da verificare se è corretto
                        onValueChanged={handleChangeDevExtreme}
                        id={field.FieldName}
                        mask={field.FormatMask}
                        maskRules={field.FormatMaskRules}
                        elementAttr={{
                          field: field.FieldName,
                        }}
                        disabled={!field.Is_Editable}
                        showMaskMode="always"
                        isValid={true}
                      />
                    ) : (
                      <TextBox
                        name={field.FieldName}
                        disabled={!field.Is_Editable}
                        value={props.myObj[field.FieldName]}
                        onValueChanged={handleChangeDevExtreme}
                        id={field.FieldName}
                        elementAttr={{
                          field: field.FieldName,
                        }}
                        placeholder={field.FormatMask}
                      />
                    )}
                    {field.HelperText && field.HelperText.length > 0 ? (
                      <Typography variant="caption" color="textSecondary">
                        {field.HelperText}
                      </Typography>
                    ) : null}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );
      }
    } else {
      // Renderizzo il campo in base al FormatType
      switch (field.FormatType) {
        case FormatTypes.Barcode:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}>
                    <Esaedro_TextBarcode
                      name={field.FieldName}
                      onBarcodeCommand={handleBarcodeCommand}
                      onBarcodeText={handleChangeDevExtreme}
                    ></Esaedro_TextBarcode>
                    {/* )} */}
                    {field.HelperText && field.HelperText.length > 0 ? (
                      <Typography variant="caption" color="textSecondary">
                        {field.HelperText}
                      </Typography>
                    ) : null}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case FormatTypes.Data:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}>
                    <DateBox
                      type="date"
                      name={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={props.myObj[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      id={field.FieldName}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      style={
                        !isValid && field.Is_Required
                          ? {
                              borderColor: !props.myObj[field.FieldName]
                                ? "red"
                                : undefined,
                              borderWidth: !props.myObj[field.FieldName]
                                ? "2px"
                                : undefined,
                              borderStyle: !props.myObj[field.FieldName]
                                ? "solid"
                                : undefined,
                            }
                          : {}
                      }
                    />
                    {/* Error message */}
                    {!isValid &&
                      field.Is_Required &&
                      !props.myObj[field.FieldName] && (
                        <Typography variant="body2" color="error">
                          {`${field.Field_Label} è obbligatorio.`}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case FormatTypes.DataOra:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>

                  <Grid item xs={fieldSizeRatio}>
                    <DateBox
                      type="datetime"
                      name={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={props.myObj[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      id={field.FieldName}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      style={
                        !isValid && field.Is_Required
                          ? {
                              borderColor: !props.myObj[field.FieldName]
                                ? "red"
                                : undefined,
                              borderWidth: !props.myObj[field.FieldName]
                                ? "2px"
                                : undefined,
                              borderStyle: !props.myObj[field.FieldName]
                                ? "solid"
                                : undefined,
                            }
                          : {}
                      }
                    />
                    {/* Error message */}
                    {!isValid &&
                      field.Is_Required &&
                      !props.myObj[field.FieldName] && (
                        <Typography variant="body2" color="error">
                          {`${field.Field_Label} è obbligatorio.`}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case FormatTypes.SoloOra: {
          let date: Date = new Date(Date.now());
          const time: smallTime = { hours: 0, minutes: 0, seconds: 0 };

          if (props.isNew) {
            if (props.myObj[field.FieldName]) {
              let myTimesStr = props.myObj[field.FieldName];

              TImeUtils.timeToParts(myTimesStr, time);

              date.setHours(time.hours);
              date.setMinutes(time.minutes);
            }
          } else {
            let myTimesStr = props.myObj[field.FieldName];

            if (myTimesStr) {
              date = new Date(Date.now());
              TImeUtils.timeToParts(myTimesStr, time);

              date.setHours(time.hours);
              date.setMinutes(time.minutes);
            }
          }

          date.setSeconds(0);
          date.setMilliseconds(0);

          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={fieldSizeRatio}>
                    <DateBox
                      type="time"
                      name={field.FieldName}
                      id={field.FieldName}
                      disabled={!field.Is_Editable}
                      displayFormat="HH:mm"
                      value={date}
                      onValueChanged={handleChangeTimeBox}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      style={
                        !isValid && field.Is_Required
                          ? {
                              borderColor: !props.myObj[field.FieldName]
                                ? "red"
                                : undefined,
                              borderWidth: !props.myObj[field.FieldName]
                                ? "2px"
                                : undefined,
                              borderStyle: !props.myObj[field.FieldName]
                                ? "solid"
                                : undefined,
                            }
                          : {}
                      }
                    />
                    {/* Error message */}
                    {!isValid &&
                      field.Is_Required &&
                      !props.myObj[field.FieldName] && (
                        <Typography variant="body2" color="error">
                          {`${field.Field_Label} è obbligatorio.`}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );
        }
        case FormatTypes.Importo:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>

                  <Grid item xs={fieldSizeRatio}></Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case FormatTypes.Quantita:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>

                  <Grid item xs={fieldSizeRatio}></Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case FormatTypes.Ditta:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>

                  <Grid item xs={fieldSizeRatio}></Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case FormatTypes.Checkbox:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>

                  <Grid item xs={fieldSizeRatio}>
                    <CheckBox
                      name={field.FieldName}
                      id={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={props.myObj[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case FormatTypes.Articolo:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>

                  <Grid item xs={fieldSizeRatio}>
                    <ArticoliLookup
                      value={props.myObj[field.FieldName]}
                      fatherObj={props.myObj}
                      id={field.FieldName}
                      isDisabled={!field.Is_Editable}
                      onValueChanged={handleChangeLookup}
                      showClearButton={true}
                      otherKeysToSet={[]}
                      renderDataGrid={true}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );

        case FormatTypes.PrevMateriali:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={labelSizeRatio} display="flex">
                    <Typography variant="body1">{field.Field_Label}</Typography>
                    {field.Is_Required ? (
                      <Typography variant="body1" color="error">
                        &nbsp; *
                      </Typography>
                    ) : null}
                  </Grid>

                  <Grid item xs={fieldSizeRatio}>
                    <PrevMaterialiLookup
                      value={props.myObj[field.FieldName]}
                      fatherObj={props.myObj}
                      id={field.FieldName}
                      isDisabled={!field.Is_Editable}
                      onValueChanged={handleChangeLookup}
                      showClearButton={true}
                      otherKeysToSet={otherKey}
                      renderDataGrid={true}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );
      }
    }
  };

  const formsGroups: FormGroup[] = React.useMemo(() => {
    if (form && form.FormsGroups) return form.FormsGroups;
    else return [];
  }, [form]);

  if (form === undefined || props.myObj === undefined) {
    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <Typography
          variant="h6"
          component="div"
          gutterBottom
          color="primary"
          textTransform={"uppercase"}
          fontWeight={600}
          textAlign={"center"}
        >
          Caricamento del form/oggetto non riuscito
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {showTitle && (
        <Typography
          variant="h6"
          component="div"
          gutterBottom
          color="primary"
          textTransform={"uppercase"}
          fontWeight={600}
          textAlign={"center"}
        >
          {form && form.Title ? form.Title : ""}
        </Typography>
      )}
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container spacing={2}>
          {formsGroups.map((group: FormGroup, i) => {
            const numCols =
              form && form.NumerOfColumns ? form.NumerOfColumns : 1;

            return (
              <React.Fragment key={i}>
                <Grid item xs={12} sm={12}>
                  <Typography
                    variant="body2"
                    component="div"
                    gutterBottom
                    color="inherit"
                    textTransform={"uppercase"}
                    fontWeight={600}
                  >
                    {group && group.GroupTitle ? group.GroupTitle : ""}
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                </Grid>
                {group.FormsFields && group.FormsFields.length > 0
                  ? group.FormsFields.map((field: FormField, j) => {
                      return renderFormField(field, j, numCols);
                    })
                  : null}
              </React.Fragment>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default RenderFormNew;
